<template>
    <v-container>
        <v-tabs v-model="tab">
            <v-tab>Belum aktif</v-tab>
            <v-tab>Sudah aktif</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless class="pt-4">
            <user-unpaid-tab></user-unpaid-tab>

            <user-paid-tab></user-paid-tab>
        </v-tabs-items>
    </v-container>
</template>

<script>
import UserUnpaidTab from './components/UserUnpaidTab'
import UserPaidTab from './components/UserPaidTab'

export default {
    components: {
        UserUnpaidTab,
        UserPaidTab,
    },

    data() {
        return {
            tab: 0,
        }
    },

    created() {
        this.$api.get(`period/${this.$route.params.period_id}`, { loader: 'appbar' })
            .then(response => {
                const title = response.data.title + (response.data.is_trial ? ' (Trial)' : '')

                this.$store.set('ui/title', title)
            })
    }
}
</script>
